const Target = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M8.5 1C7.04184 1.00172 5.64389 1.58174 4.61282 2.61281C3.58174 3.64389 3.00172 5.04184 3 6.5C2.99866 7.69155 3.38786 8.8507 4.108 9.8C4.108 9.8 4.258 9.9975 4.2825 10.026L8.5 15L12.7195 10.0235C12.7415 9.997 12.892 9.8 12.892 9.8L12.8925 9.7985C13.6122 8.84954 14.0012 7.69098 14 6.5C13.9983 5.04184 13.4183 3.64389 12.3872 2.61281C11.3561 1.58174 9.95817 1.00172 8.5 1ZM8.5 8.5C8.10444 8.5 7.71776 8.3827 7.38886 8.16294C7.05996 7.94318 6.80362 7.63082 6.65224 7.26537C6.50087 6.89991 6.46126 6.49778 6.53843 6.10982C6.6156 5.72186 6.80608 5.36549 7.08579 5.08579C7.36549 4.80608 7.72186 4.6156 8.10982 4.53843C8.49778 4.46126 8.89992 4.50087 9.26537 4.65224C9.63082 4.80362 9.94318 5.05996 10.1629 5.38886C10.3827 5.71776 10.5 6.10444 10.5 6.5C10.4993 7.03023 10.2884 7.53855 9.91349 7.91348C9.53856 8.28841 9.03023 8.49934 8.5 8.5Z"
        fill="#5D6977"
      />
    </svg>
  );
};

export default Target;
